import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getCompanyDetails(action: any): any {
    // const yieldPuts = [{ type: ACTIONS.COMPANY.GET_COMPANY_DETAILS, payload: "item" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.COMPANY.GET_COMPANY_DETAILS, action.payload, true);
}

export function* updateCompanyDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.COMPANY.UPDATE_COMPANY_DETAILS, action.payload, true);
}